// extracted by mini-css-extract-plugin
export default {"content":"rgXU4","day":"_3I-YQ","past":"_14A3y","dayText":"QzuPC","today":"_3eI1l","events":"_3iBxx","event":"_33FSv"};